<template>
    <div
        class="flex-wrap tablet-sm:flex-nowrap
               gap-x-4
               mx-1 tablet-sm:mx-4 tablet-lg:mx-8 my-0.5 tablet-lg:my-1 flex my-1"
    >
        <slot></slot>
    </div>
</template>
